import da from "../locales/da.json";
import de from "../locales/de.json";
import en from "../locales/en.json";
import no from "../locales/no.json";
import se from "../locales/se.json";
import pt from "../locales/pt.json";
import fi from "../locales/fi.json";
import pl from "../locales/pl.json";
import nl from "../locales/nl.json";
export default () => ({
	legacy: false,
	locale: "en_US",
	fallbackLocale: "en_US",
	messages: {
		da_DK: da,
		en_US: en,
		de_DE: de,
		nb_NO: no,
		sv_SE: se,
		pt_PT: pt,
		fi_FI: fi,
		pl_PL: pl,
		nl_NL: nl
	}
});
